<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header ">
                    <h5 class="font-medium m-0">📄 Add CCL PDS Misutilization Data</h5>
                </div>
                <div class="card-body">
                    <form [formGroup]="pdsForm">
                        <div class="row align-items-end">


                            <!-- Block Office -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="blockOffice">
                                    <option value="" selected>--Select--</option>
                                </select>
                                <div *ngIf="pdsForm.get('blockOffice')?.touched && pdsForm.get('blockOffice')?.invalid"
                                    class="text-danger small">
                                    block Office is required
                                </div>
                            </div>

                            <!-- Financial Year -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Defaulter Society<span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="financialYear">
                                    <option value="">--Select--</option>


                                </select>
                                <div *ngIf="pdsForm.get('financialYear')?.touched && pdsForm.get('financialYear')?.invalid"
                                    class="text-danger small">
                                    Financial year is required
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 mb-2">

                                <label class="form-label">Misutilization since Year<span
                                        class="text-danger">*</span></label>
                                <input class="form-control" type="number" formControlName="target"
                                    placeholder="target*" />
                                <!-- <div *ngIf="row.get('target')?.invalid && (row.get('target')?.touched )">
                  <small class="text-danger" *ngIf="row.get('target')?.errors?.['required']">
                    First name is required.
                  </small>
                </div> -->
                            </div>
                            <div class="col-lg-4 col-md-6 mb-2">

                                <label class="form-label">Reporting Year<span class="text-danger">*</span></label>
                                <input class="form-control" type="number" formControlName="target"
                                    placeholder="target*" />
                                <!-- <div *ngIf="row.get('target')?.invalid && (row.get('target')?.touched )">
                  <small class="text-danger" *ngIf="row.get('target')?.errors?.['required']">
                    First name is required.
                  </small>
                </div> -->
                            </div>
                            <div class="col-lg-4 col-md-6 mb-2">

                                <label class="form-label">Balance as On<span class="text-danger">*</span></label>
                                <div class="input-group">
                                    <span class="input-group-text">₹</span>
                                    <input type="number" class="form-control" formControlName="amount" />
                                    <!-- <span class="input-group-text">.00</span> -->
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 mb-2">

                                <label class="form-label">Amount recovered during May,2025<span
                                        class="text-danger">*</span></label>
                                <div class="input-group">
                                    <span class="input-group-text">₹</span>
                                    <input type="number" class="form-control" formControlName="amount" />
                                    <!-- <span class="input-group-text">.00</span> -->
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 mb-2">

                                <label class="form-label">Legal Action Taken for recovery against the defaulter<span
                                        class="text-danger">*</span></label>
                                <input class="form-control" type="number" formControlName="target"
                                    placeholder="target*" />
                                <!-- <div *ngIf="row.get('target')?.invalid && (row.get('target')?.touched )">
                  <small class="text-danger" *ngIf="row.get('target')?.errors?.['required']">
                    First name is required.
                  </small>
                </div> -->
                            </div>
                            <!-- Submit -->
                            <div class="col-lg-12 text-end">
                                <button type="submit" class="btn btn-primary" [disabled]="pdsForm.invalid">
                                    Get Report
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>